import { render, staticRenderFns } from "./MailComposeForm.vue?vue&type=template&id=088663dd"
import script from "./MailComposeForm.vue?vue&type=script&lang=js"
export * from "./MailComposeForm.vue?vue&type=script&lang=js"
import style0 from "./MailComposeForm.vue?vue&type=style&index=0&id=088663dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports